<template>
  <!-- 主容器 -->
  <div class="app-container">
    <!-- 搜索区域 -->
    <el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="80px">
      <!-- 教师姓名搜索 -->
      <el-form-item label="教师姓名" prop="teacherName">
        <el-input v-model="queryParams.teacherName" placeholder="请输入教师姓名" clearable size="small"
          @keyup.enter.native="handleQuery" />
      </el-form-item>

      <!-- 性别搜索
      <el-form-item label="性别" prop="sex">
        <el-select v-model="queryParams.sex" placeholder="请选择性别" clearable size="small">
          <el-option label="男" :value="0" />
          <el-option label="女" :value="1" />
        </el-select>
      </el-form-item> -->

      <!-- 搜索按钮 -->
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">
          搜索
        </el-button>
        <el-button icon="el-icon-refresh" size="small" @click="resetQuery">
          重置
        </el-button>
      </el-form-item>
    </el-form>

    <!-- 操作按钮区域 -->
    <el-row :gutter="10" class="mb8">
      <!-- 新增按钮 -->
      <el-col :span="1.5">
        <el-button type="primary" plain icon="el-icon-plus" size="small" @click="handleAdd">
          新增
        </el-button>
      </el-col>

      <el-col :span="1.5">
        <el-button type="success" plain icon="el-icon-edit" size="mini" :disabled="single"
          @click="handleUpdate">修改</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="danger" plain icon="el-icon-delete" size="mini" :disabled="multiple"
          @click="handleDelete">删除</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="warning" plain icon="el-icon-download" size="mini" @click="handleExport">导出</el-button>
      </el-col>
    </el-row>

    <!-- 数据表格 -->
    <el-table v-loading="loading" :data="teacherList" @selection-change="handleSelectionChange" class="table-container">
      <!-- 选择列 -->
      <el-table-column type="selection" width="55" align="center" />

      <!-- 教师ID列 -->
      <el-table-column label="教师ID" align="center" prop="id" width="80" />

      <!-- 教师姓名列 -->
      <el-table-column label="教师姓名" align="center" prop="teacherName" />

      <!-- 性别列
      <el-table-column label="性别" align="center" prop="sex" width="80">
        <template slot-scope="scope">
          {{ scope.row.sex === '0' ? '男' : '女' }}
        </template>
      </el-table-column> -->

      <!-- 任教班级列 -->
      <el-table-column label="任教班级" align="center" prop="classNames">
        <template slot-scope="scope">
          <el-tooltip effect="dark" :content="scope.row.classNames" placement="top"
            v-if="scope.row.classNames.length > 20">
            <span>{{ scope.row.classNames.substring(0, 20) }}...</span>
          </el-tooltip>
          <span v-else>{{ scope.row.classNames }}</span>
        </template>
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="180">
        <template slot-scope="scope">
          <!-- 修改按钮 -->
          <el-button size="mini" type="text" icon="el-icon-edit" @click="handleUpdate(scope.row)">
            修改
          </el-button>

          <!-- 删除按钮 -->
          <el-button size="mini" type="text" icon="el-icon-delete" @click="handleDelete(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <el-pagination background class="pagination-container" v-show="total > 0" :current-page="queryParams.pageNum"
      :page-sizes="[5, 10, 20, 50]" :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper"
      :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body @close="cancel">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <!-- 用户名输入 -->
        <el-form-item label="用户名" prop="userName">
          <el-input v-model="form.userName" placeholder="请输入用户名" />
        </el-form-item>

        <!-- 密码输入 -->
        <el-form-item label="密码" prop="password" v-if="!form.id">
          <el-input v-model="form.password" type="password" placeholder="请输入密码" />
        </el-form-item>

        <!-- 教师姓名输入 -->
        <el-form-item label="教师姓名" prop="teacherName">
          <el-input v-model="form.teacherName" placeholder="请输入教师姓名" />
        </el-form-item>

        <!-- 性别选择
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="form.sex">
            <el-radio label="0">男</el-radio>
            <el-radio label="1">女</el-radio>
          </el-radio-group>
        </el-form-item> -->

        <!-- 多选班级 -->
        <el-form-item label="任教班级" prop="classIds">
          <el-select v-model="form.classIds" multiple placeholder="请选择任教班级" style="width: 100%">
            <el-option v-for="classItem in classList" :key="classItem.id" :label="classItem.className"
              :value="classItem.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <!-- 对话框底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listTeachers, getTeachers, delTeachers, addTeachers, updateTeachers } from "@/api/OmdTeachers/teachers";
import { listClasses } from "@/api/OmdClasses/classes";
import { addUser } from "@/api/system/user";
import { addClasses as addTeacherClasses, delClassesteid } from "@/api/OmdTeacherClasses/classes";
import { download } from "@/utils/request";

export default {
  name: "TeacherMain",
  data() {
    return {
      // 加载状态
      loading: true,
      // 选中行的ID数组
      ids: [],
      // 是否单选（用于判断修改按钮状态）
      single: true,
      // 是否多选（用于判断删除按钮状态）
      multiple: true,
      // 是否显示搜索区域
      showSearch: true,
      // 总条数
      total: 0,
      // 教师列表数据
      teacherList: [],
      // 班级列表数据
      classList: [],
      // 对话框标题
      title: "",
      // 是否显示对话框
      open: false,

      // 查询参数
      queryParams: {
        pageNum: 1,       // 当前页码
        pageSize: 10,     // 每页条数
        teacherName: null,  // 教师姓名
        // sex: null,        // 性别
      },

      // 表单数据
      form: {
        id: null,         // 教师ID
        userName: null,   // 用户名
        password: null,   // 密码
        teacherName: null,  // 教师姓名
        // sex: '0',           // 性别，默认男
        classIds: [],      // 任教班级ID数组
      },

      // 表单验证规则
      rules: {
        userName: [
          { required: true, message: "用户名不能为空", trigger: "blur" }
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" }
        ],
        teacherName: [
          { required: true, message: "教师姓名不能为空", trigger: "blur" }
        ],
        // sex: [
        //   { required: true, message: "请选择性别", trigger: "change" }
        // ],
        classIds: [
          { type: 'array', message: "请选择任教班级", trigger: "change" }
        ]
      }
    };
  },
  created() {
    this.getList();
    this.getClassList();
  },
  methods: {
    /**
     * 获取教师列表
     * @return {void}
     */
    async getList() {
      this.loading = true;
      try {
        const response = await listTeachers(this.queryParams);
        this.teacherList = response.rows || response.data;
        this.total = response.total;
        console.log("教师列表",this.teacherList);

        // 处理班级数据为逗号分隔字符串
        this.teacherList.forEach(teacher => {
          teacher.classNames = teacher.classes
            ? teacher.classes.map(c => c.className).join(', ')
            : '无';
        });
      } catch (error) {
        console.error("获取教师列表失败:", error);
        this.$message.error("获取数据失败");
      } finally {
        this.loading = false;
      }
    },

    /**
     * 获取班级列表
     * @return {void}
     */
    getClassList() {
      listClasses()
        .then(response => {
          this.classList = response.rows || response.data;
        })
        .catch(error => {
          console.error("获取班级列表失败:", error);
        });
    },

    /**
     * 每页条数变化事件
     * @param {number} val 新的每页条数
     * @return {void}
     */
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },

    /**
     * 当前页变化事件
     * @param {number} val 新的页码
     * @return {void}
     */
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },

    /**
     * 取消操作（关闭对话框）
     * @return {void}
     */
    cancel() {
      this.open = false;
      this.reset();
    },

    /**
     * 重置表单
     * @return {void}
     */
    reset() {
      this.form = {
        id: null,
        userName: null,
        password: null,
        teacherName: null,
        // sex: '0',
        classIds: []
      };
      // 重置表单验证状态
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },

    /**
     * 搜索操作
     * @return {void}
     */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },

    /**
     * 重置搜索表单
     * @return {void}
     */
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        teacherName: null,
        // sex: null
      };
      this.handleQuery();
    },

    /**
     * 表格选择项变化事件
     * @param {Array} selection 选中的行数据
     * @return {void}
     */
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },

    /**
     * 新增操作
     * @return {void}
     */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加教师";
    },

    /**
     * 修改操作
     * @param {Object} row 行数据
     * @return {void}
     */
    handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids[0];
      alert(id);
      getTeachers(id)
        .then(response => {
          const teacherData = response.data;
          console.log("老师详情:",teacherData);
          this.form = {
            id: teacherData.id,
            userName: teacherData.userName,
            teacherName: teacherData.teacherName,
            // sex: teacherData.sex || '0',
            classIds: teacherData.classes ? teacherData.classes.map(c => c.id) : []
          };
          this.open = true;
          this.title = "修改教师";
        })
        .catch(error => {
          console.error("获取教师详情失败:", error);
        });
    },

    /**
     * 提交表单
     * @return {void}
     */
    async submitForm() {
      this.$refs["form"].validate(async valid => {
        if (valid) {
          try {
            if (this.form.id) {
              // 修改教师信息
              // 1. 更新教师基本信息
              await updateTeachers({
                id: this.form.id,
                name: this.form.teacherName,
                // sex: this.form.sex
              });

              // 2. 删除原有班级关联
              await delClassesteid(this.form.id);

              // 3. 添加新的班级关联
              const promises = this.form.classIds.map(classId => {
                return addTeacherClasses({
                  teacherId: this.form.id,
                  classId: classId
                });
              });

              await Promise.all(promises);

              this.$modal.msgSuccess("修改成功");
            } else {
              // 新增教师信息
              // 1. 先创建用户
              const userRes = await addUser({
                userName: this.form.userName,
                password: this.form.password,
                sex: this.form.sex,
                remark: "教师",
                deptId: 101,
                nickName: this.form.teacherName,
              });

              //创建一个老师

              if (userRes.code === 200) {
                // 2. 创建教师信息
                const teacherRes = await addTeachers({
                  teacherName: this.form.teacherName,
                  userId: userRes.data.userId,
                  sex: this.form.sex
                });

                //3.添加班级关联
                if (teacherRes.code === 200) {
                  // 3. 添加教师与班级的关联关系
                  const teacherId = teacherRes.data.id;
                  const promises = this.form.classIds.map(classId => {
                    return addTeacherClasses({
                      teacherId: teacherId,
                      classId: classId
                    });
                  });

                  await Promise.all(promises);
                }
              }

              this.$modal.msgSuccess("添加成功");
            }

            this.open = false;
            this.getList();
          } catch (error) {
            console.error("操作失败:", error);
            this.$modal.msgError("操作失败");
          }
        }
      });
    },

    /**
     * 删除操作
     * @param {Object|Number} row 行数据或ID
     * @return {void}
     */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$confirm(`是否确认删除编号为"${ids}"的教师？`, '警告', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass: 'confirm-danger-button',
        cancelButtonClass: 'cancel-button'
      })
        .then(() => delTeachers(ids))
        .then(() => {
          this.getList();
          this.$message.success('删除成功');
        })
        .catch(() => { });
    },

    /** 导出按钮操作 */
    handleExport() {
      download('/OmdTeachers/teachers/export', {
        ...this.queryParams
      }, `教师表_${new Date().getTime()}.xlsx`)
    }
  }
}
</script>

<style scoped>
/* 主容器样式 */
.app-container {
  padding: 20px;
}

/* 表格操作按钮紧凑样式 */
.small-padding .el-button {
  padding: 5px;
  margin-left: 0;
}

/* 表格头部*/
::v-deep .el-table__header-wrapper .el-table__header th {
  background-color: #f4f4f4 !important;
  color: #000 !important;
}

/* 分页器样式 */
::v-deep .el-pager li.active {
  background-color: var(--primary-color) !important;
  color: white !important;
  border-color: var(--primary-color) !important;
  font-weight: bold;
  cursor: pointer;
}

/* 分页器样式 */
::v-deep .el-pager li.active:hover {
  background-color: #d6336c !important;
  color: white !important;
  background-color: #d6336c !important;
  font-weight: bold;
  cursor: pointer;
}

/*按钮的样式 主要按钮 的样式*/
::v-deep .el-button--primary {
  color: #fff;
  background-color: var(--primary-color);
  border: 1px solid var(--primary-color);
}

/*鼠标获得焦点的样式*/
::v-deep .el-button--primary:hover {
  background-color: #d6336c !important;
}

/* 在全局样式文件中添加 */
::v-deep .el-button:focus {
  outline: none !important;
  box-shadow: none !important;
}

/* 如果按钮是 plain 样式 */
::v-deep.el-button--plain:focus {
  outline: none !important;
  box-shadow: none !important;
}

/* 文本框鼠标获得焦点边框 */
::v-deep .el-input__inner:focus {
  border-color: var(--primary-color) !important;
}

/* 如果是 textarea */
::v-deep .el-textarea__inner:focus {
  border-color: var(--primary-color) !important;
}

/* 在全局样式或组件样式中添加 */
::v-deep.confirm-delete-button {
  background-color: #f56c6c !important;
  border-color: #f56c6c !important;
}

::v-deep.confirm-delete-button:hover {
  background-color: #e05c5c !important;
  border-color: #e05c5c !important;
}
</style>